import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export default function sanitizeForFileName(text) {
  return text.replace(/["*/:<>?\\|]/g, '-');
}